function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import BaseButton from '../../base-button';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Button = /*#__PURE__*/forwardRef((props, ref) => ___EmotionJSX(BaseButton, _extends({
  forwardRef: ref
}, props)));
Button.displayName = 'Button';
export default Button;